<template>
    <div class="wrapper">
        <div class="wrapper__header">
            <or-alert
                v-if="!isCurrentStatusEqualReady"
                type="warning"
                :dismissible="false"
            >
              {{ $t('model.nlu-model.sidebar.testpreview.testservice.dataIsNot') }}
            </or-alert>
            <or-alert
                v-else-if="isDataChangeAfterTrain"
                type="warning"
                :dismissible="false"
            >
              {{ $t('model.nlu-model.sidebar.testpreview.testservice.youDataHas') }}
            </or-alert>
        </div>
        <div class="wrapper__form">
            <or-select
                v-model="testContext"
                :label="$t('model.nlu-model.sidebar.testpreview.testservice.context')"
                :options="$props.contexts"
                :disabled="$props.isLoading"
            />
            <or-textbox
                v-model="localPhrase"
                :placeholder="$t('model.nlu-model.sidebar.testpreview.testservice.testPhrase.placeholder')"
                :invalid="testPhraseInvalid"
                :error="errors"
                :disabled="$props.isLoading"
                autofocus
                :help="$t('model.nlu-model.sidebar.testpreview.testservice.testPhrase.helpText')"
                @keydown-enter="testPhraseHandler"
            />
            <or-button
                type="primary"
                color="primary"
                class="test-btn"
                :loading="phraseIsTesting"
                :disabled="isTestButtonDisabled"
                @click="testPhraseHandler"
            >
              {{ $t('model.nlu-model.sidebar.testpreview.testservice.test') }}
            </or-button>
        </div>
        <div
            v-show="showTopAnswers"
            class="wrapper__results"
        >
            <phrase-item
                v-if="!$props.isLoading"
                :phrase="queryPhrase"
            />
            <transition-group
                name="answers"
                tag="div"
            >
                <response-item
                    v-for="response in topAnswers"
                    :key="response.answerId"
                    :response="response"
                    @click.native="$emit('inspect-response', response)"
                />
            </transition-group>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { testPhraseValidationMixin } from '@/mixins/test-phrase-validation.mixin'
import responseItem from './ResponseItem'
import phraseItem from './PhraseItem'

export default {
  components: { responseItem, phraseItem },

  mixins: [testPhraseValidationMixin],

  created () {
    this.testContext = this.$props.selectedContext || 'all'
  },

  props: {
    isLoading: Boolean,
    phrase: String,
    contexts: Array,
    testResponse: Object,
    selectedContext: {
      type: String,
      required: false
    }
  },

  computed: {
    ...mapState('knowledgebase/test', ['phraseIsTesting']),
    ...mapState('knowledgebase/statuses', ['statusSet']),
    ...mapGetters('knowledgebase/versions', ['isVersionModified']),
    ...mapGetters('knowledgebase/statuses', ['currentStatus']),

    localPhrase: {
      get () {
        return this.phrase || ''
      },
      set (value) {
        this.$v.localPhrase.$touch()
        this.$emit('update:phrase', value)
      }
    },

    queryPhrase () {
      return this.$props.testResponse
        ? this.$props.testResponse.result.question
        : ''
    },

    topAnswers () {
      return this.$props.testResponse
        ? _.filter(this.$props.testResponse.result.topAnswers, obj => !_.isEmpty(obj.type))
        : []
    },

    showTopAnswers () {
      return !_.isEmpty(this.topAnswers)
    },

    isCurrentStatusEqualReady () {
      return this.currentStatus === 'READY'
    },

    isDataChangeAfterTrain () {
      return this.isCurrentStatusEqualReady && this.isVersionModified
    },

    testPhraseInvalid () {
      return this.$v.localPhrase.$invalid && this.$v.localPhrase.$dirty
    },

    isTestButtonDisabled () {
      return this.$v.localPhrase.$invalid || !this.isCurrentStatusEqualReady
    }
  },

  data () {
    return {
      testContext: ''
    }
  },

  methods: {
    testPhraseHandler () {
      if (!_.isEmpty(this.localPhrase)) {
        this.$emit('submit', {
          phrase: this.localPhrase,
          context: this.testContext
        })
      } else {
        this.$v.localPhrase.$touch()
      }
    },

    resetPhraseValidation () {
      this.$nextTick(() => this.$v.localPhrase.$reset())
    }
  },

  watch: {
    selectedContext (newContext) {
      this.context = newContext || ''
    }
  }
}
</script>

<style lang="scss" scoped>
    .answers-enter-active, .answers-leave-active {
        transition: all 1s;
    }

    .answers-enter {
        opacity: 0;
        transform: translateY(20px);
    }

    .answers-leave-to {
        opacity: 0;
    }

    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        &__header, &__form, &__results {
            display: flex;
            padding: $sp-3;
        }

        &__header {
            flex-direction: column;
            align-items: flex-end;
            padding-bottom: 0;
        }

        &__form {
            flex-direction: column;
            padding-top: 0;
            margin-bottom: auto;

            .test-btn {
                align-self: flex-end;
                margin-top: $sp-3;
            }
        }

        &__results {
            flex-direction: column;
            flex-grow: 1;
            overflow: scroll;
        }
    }
</style>
